// @flow
import React from 'react';
import styled from 'styled-components';
import ToolCard from './ToolCard';

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding: 0 8px 8px;
  margin-top: 22px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.10);
  background-color: ${({ theme }) => theme.colors.backgroundMuted};

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const COLUMN_1_IDS = ['app-push', 'pagebuilder', 'app-features'];
const COLUMN_2_IDS = ['email-alerts', 'newsletters'];
const COLUMN_3_IDS = ['liveblog', 'swipeable', 'weekend-note', 'apple-news'];

type Tool = {
  id: string;
  title: string;
  bgColor: string;
  icon: string;
  actionButton?: string;
  links?: string[];
  hasLiveBadge?: boolean;
};

type Props = {
  tools: Tool[];
};

const renderColumn = (toolsById: { [string]: Tool }, ids: string[]) =>
  ids
    .map((id) => toolsById[id])
    .filter(Boolean)
    .map((tool) => (
      <ToolCard
        key={tool.id}
        id={tool.id}
        title={tool.title}
        bgColor={tool.bgColor}
        icon={tool.icon}
        actionButton={tool.actionButton}
        links={tool.links}
        hasLiveBadge={tool.hasLiveBadge}
        route={tool.route}
      />
    ));

const ToolsGrid: React.FC<Props> = ({ tools }) => {
  const toolsById = tools.reduce((acc, t) => ({ ...acc, [t.id]: t }), {});

  return (
    <GridContainer>
      <Column>{renderColumn(toolsById, COLUMN_1_IDS)}</Column>
      <Column>{renderColumn(toolsById, COLUMN_2_IDS)}</Column>
      <Column>{renderColumn(toolsById, COLUMN_3_IDS)}</Column>
    </GridContainer>
  );
};

export default React.memo(ToolsGrid);
